var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"modal",attrs:{"centered":"","hide-header":"","ok-only":""}},_vm._l((_vm.completeMsg),function(msg,i){return _c('div',{key:i,staticClass:"text-center",class:{
      'text-danger': !msg.success,
      'text-success': msg.success,
    }},[_c('b-icon',{staticStyle:{"width":"80px","height":"80px"},attrs:{"icon":msg.success ? 'check-circle' : 'x-circle',"variant":msg.success ? 'success' : 'danger'}}),_c('div',{staticClass:"mt-2"},[_vm._v(" "+_vm._s(msg.detail)+" ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }